import React from 'react';
import { push } from 'connected-react-router';
import { closeAlert } from '../../actions/commonsActions';
import { userLogin, passwdRecover } from '../../actions/authActions';
import {
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Input,
	FormGroup,
	Form,
	Row,
	Col,
	Button,
	Alert
} from 'reactstrap';
import img1 from '../../assets/images/ap/ap-small.jpg';
import img2 from '../../assets/images/background/login-register.jpg';
import connect from "react-redux/es/connect/connect";


const sidebarBackground = {
	backgroundImage: "url(" + img2 + ")",
	backgroundRepeat: "no-repeat",
	backgroundPosition: "bottom center"
};

const alerStyle = {
	position: 'relative',
  	top: '0',
  	right: '0'
}

class Login extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
		  email: '',
		  password: ''
		};
	};

	handleClick = () => {
		const elem = document.getElementById('loginform');
		elem.style.transition = "all 2s ease-in-out";
		elem.style.display = "none";
		document.getElementById('recoverform').style.display = "block";
	};

	submitClick = event => {
		event.preventDefault();
		const loginForm = document.getElementById('loginform');

		this.props.userLogin({
			username: this.state.email,
			password: this.state.password
		}).then(() => {
			loginForm.reset();
			this.props.changeLocation('/');
		}, error => {
			console.log(error);
		})
	};

	signUp = event => {
		event.preventDefault();
		this.props.closeAlert();
		this.props.changeLocation('/register');
	};

	onInputChange = event => {
		this.setState({
		  [event.target.name]: event.target.value
		});
  	};

	isFormValid = () => {
		return this.state.email.length && this.state.password.length;
	};

	onRecoverInputFocus = () => {
		this.props.closeAlert();
	};

	onRecover = event => {
		event.preventDefault();
		const form = event.target;
		const email = form.elements['email'].value;
		console.log(email);
		this.props.passwdRecover(email)
				.then(res => {
					if (res.status === 'OK') {
						document.getElementById('recoverform').style.display = 'none';
						form.reset();
						setTimeout(() => {
							//this.props.changeLocation('/');
							document.getElementById('loginform').style.display = 'block';
						}, 3000);
					} else {
						form.reset();
					}
			});
	};

	render() {
		return <div className="">
			{/*--------------------------------------------------------------------------------*/}
			{/*Login Cards*/}
			{/*--------------------------------------------------------------------------------*/}
			<div className="auth-wrapper d-flex no-block justify-content-center align-items-center" style={sidebarBackground}>
				<div className="auth-box on-sidebar">
					<div id="mainform">
						<div className="logo">
							<span className="db"><img src={img1} alt="logo" /></span>
							<h5 className="font-medium mb-3">Sign In to Admin</h5>
						</div>
						<Row>
							<Col xs="12">
								<Form
									className="mt-3"
									id="loginform"
									action="/dashboard"
									onSubmit={this.submitClick}
								>
									<InputGroup className="mb-3">
										<InputGroupAddon addonType="prepend">
											<InputGroupText>
												<i className="ti-user"></i>
											</InputGroupText>
										</InputGroupAddon>
										<Input
											type="text"
											placeholder="Email"
											name="email"
											required
											value={this.state.email}
                      						onChange={this.onInputChange}
											onFocus={this.props.closeAlert} />
									</InputGroup>
									<InputGroup className="mb-3">
										<InputGroupAddon addonType="prepend">
											<InputGroupText>
												<i className="ti-pencil"></i>
											</InputGroupText>
										</InputGroupAddon>
										<Input
											type="password"
											placeholder="Password"
											name="password"
											required
											value={this.state.password}
                      onChange={this.onInputChange}
											onFocus={this.props.closeAlert} />
									</InputGroup>
									{/* <div className="d-flex no-block align-items-center mb-3">
										<CustomInput type="checkbox" id="exampleCustomCheckbox" label="Remember Me" />
										<div className="ml-auto">
											<a href="#recoverform" id="to-recover" onClick={this.handleClick} className="forgot text-dark float-right"><i className="fa fa-lock mr-1"></i> Forgot pwd?</a>
										</div>
									</div>
									*/}
									<div className="d-flex no-block align-items-center mb-3">
										<div className="ml-auto">
											<a href="#recoverform" id="to-recover" onClick={this.handleClick} className="forgot text-dark float-right"><i className="fa fa-lock mr-1"></i> Forgot pwd?</a>
										</div>
									</div>
									<Row className="mb-3">
										<Col xs="12">
											<Button
												color="primary"
												size="lg"
												type="submit"
												block
												className={`text-uppercase ${
                          this.isFormValid() ? '' : 'disabled'
                        }`}
											>
												Log In
											</Button>
										</Col>
									</Row>
									<div className="text-center">
										Do not have an account? <a href="/register" className="text-info ml-1" onClick={this.signUp}><b>Sign Up</b></a>
									</div>
								</Form>
							</Col>
						</Row>
					</div>
					<div id="recoverform">
						<div className="logo">
							<span>Enter your Email and instructions will be sent to you!</span>
						</div>
						<Row className="mt-3">
							<Col xs="12">
								<Form action="/recover" style={{marginBottom: '20px'}} onSubmit={this.onRecover}>
									<FormGroup>
										<Input
											type="email"
											name="email"
											bsSize="lg"
											id="email"
											placeholder="Email"
											onFocus={this.onRecoverInputFocus}
											required />
									</FormGroup>
									<Row className="mt-3">
										<Col xs="12">
											<Button color="danger" size="lg" type="submit" block>Reset</Button>
										</Col>
									</Row>
								</Form>
							</Col>
						</Row>
					</div>
					{/*----------------------- alerts -----------------------------------*/}
					<Alert
						style={alerStyle}
						color={`${this.props.alert.alert.status}`}
						isOpen={this.props.alert.isOpen || false}
					>
							{this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed": ''}
					</Alert>
				</div>
			</div>
		</div>;
	}
}

const mapDispatchToProps = dispatch => {
	return {
		userLogin: (credentials) => dispatch(userLogin(credentials)),
		changeLocation: (url) => dispatch(push(url)),
		closeAlert: () => dispatch(closeAlert()),
		passwdRecover: email => dispatch(passwdRecover(email)),
	};
};

const mapStateToProps = state => ({
	isAuth: state.isAuth,
	currentUser: state.currentUser,
	alert: state.alert
});

export default connect(mapStateToProps, mapDispatchToProps)(Login)



// WEBPACK FOOTER //
// ./src/views/authentication/login.jsx